module.exports = __webpack_public_path__ + "static/media/ecosup.a6d85110.png";